module.exports = "/_next/static/images/invoice-financing-1ceb53baa96760006a52b3ff8173b370.svg";